const WAITLIST_ANSWER = 3;

/**
 * True when the reply has no other answer than "on the waitlist". Such a reply is handled in the
 * waitlist and not listed among the replies. A reply with a place or a "no" for some time stays
 * among the replies, also when it is on the waitlist for another time.
 */
export const isOnlyOnWaitlist = (reply: any): boolean => {
    const answers: any[] = reply?.replyTime ?? [];
    return answers.length > 0 && answers.every(answer => answer.customerAnswerType === WAITLIST_ANSWER);
};
